import './EyeLoading.scss';

const EyeLoading = () => {
  return <div className='eye-loader' />;
};

export default EyeLoading;
